export const REACT_APP_GOOGLE_API = process.env.REACT_APP_GOOGLE_API
export const REACT_APP_GOOGLE_API_IOS = process.env.REACT_APP_GOOGLE_API_IOS
export const REACT_APP_GOOGLE_API_ANDROID = process.env.REACT_APP_GOOGLE_API_ANDROID
export const REACT_APP_GOOGLE_API_GEOS = process.env.REACT_APP_GOOGLE_API_GEOS